<template>
  <div class="index-block" :data-conference="data.id">
    <router-link
      v-if="data.routerLink"
      class="index-block__wrapper"
      :to="data.url"
      @mouseenter.native="$eventHub.$emit('morphCursor', 'circle')"
      @mouseleave.native="$eventHub.$emit('morphCursor', 'rect')"
    >
      <div class="index-block__title-cont">
        <h3 class="index-block__title">{{ data.title }}</h3>
        <AppPicture
          v-if="data.soldout"
          class="index-block__sold-out"
          :data="{ src: `/img/welcome/${data.soldout}.svg`, alt: 'Sold out' }"
          :lazy="false"
          :isImg="true"
        />
      </div>
      <div class="index-block__picture-cont">
        <AppPicture
          class="index-block__picture"
          :data="{ src: data.image, alt: data.title }"
          :lazy="false"
          :isImg="true"
        />
        <p class="index-block__picture-text">
          <span>Awwwards</span>
        </p>
        <p class="index-block__picture-text">
          <span>Conference</span>
        </p>
      </div>
      <p class="index-block__content">
        <span v-html="data.subtitle" />
      </p>
      <AppButton
        class="index-block__button"
        :router="true"
        :isHoverable="false"
        :isAnimated="false"
        :data="{
          content: 'Jump in',
          url: data.url,
        }"
      />
    </router-link>
    <a
      v-else
      class="index-block__wrapper"
      :href="data.url"
      rel="noopener"
      @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
      @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
    >
      <div class="index-block__title-cont">
        <h3 class="index-block__title">{{ data.title }}</h3>
        <AppPicture
          v-if="data.soldout"
          class="index-block__sold-out"
          :data="{ src: '/img/welcome/soldout_tokyo.svg', alt: 'Sold out' }"
          :lazy="false"
          :isImg="true"
        />
      </div>
      <div class="index-block__picture-cont">
        <AppPicture
          class="index-block__picture"
          :data="{ src: data.image, alt: data.title }"
          :lazy="false"
          :isImg="true"
          :isAnimated="false"
        />
        <p class="index-block__picture-text">
          <span>Awwwards</span>
        </p>
        <p class="index-block__picture-text">
          <span>Conference</span>
        </p>
      </div>
      <p class="index-block__content">
        <span v-html="data.subtitle" />
      </p>
      <AppButton
        class="index-block__button"
        :router="false"
        :isAnimated="false"
        :isHoverable="false"
        :data="{
          content: 'Jump in',
          url: data.url,
        }"
      />
    </a>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';
import AppPicture from '@/components/AppPicture.vue';

export default {
  name: 'IndexBlock',
  components: {
    AppButton,
    AppPicture,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.index-block {
  position: relative;
  flex: 1 0 auto;
  width: 100%;
  background-color: $color-white;

  display: flex;
  align-items: center;
  justify-content: center;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: column nowrap;

    @include mq(ipadL) {
      transform: translateY(40px);
    }
  }

  &__title-cont {
    position: relative;
  }

  &__title {
    margin: 0;
  }

  &__picture-cont {
    position: relative;
  }

  &__picture {
    position: relative;
    width: 55vw;
    margin: 10% 0;

    @include mq(mobileL) {
      margin: 10% 0;
    }

    @include mq(ipadP) {
      width: 15vw;
      margin: 15% 0;
    }

    @include mq(ipadL) {
      margin: 30% 0;
    }

    @include mq(ipadP, $and: $is-touch-device) {
      width: 25vw;
    }

    @include mq(ipadL) {
      width: 18vw;
    }

    @include mq(ds) {
      width: 10vw;
    }

    &::v-deep .picture__img {
      mix-blend-mode: unset;
    }
  }

  &__content {
    margin-bottom: 30px;
    text-align: center;

    @include mq(ipadL) {
      margin-bottom: 60px;
    }
  }

  &__picture-text {
    position: absolute;
    top: 50%;
    width: 0;
    white-space: nowrap;
    transform-origin: 50% 50%;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }

    &:nth-child(2) {
      left: 0;

      transform: translateX(-35px) rotate(-90deg);

      @include mq(ipadL) {
        transform: translateX(-55px) rotate(-90deg);
      }
    }

    &:nth-child(3) {
      right: 0;

      transform: translateX(35px) rotate(-90deg);

      @include mq(ipadL) {
        transform: translateX(55px) rotate(-90deg);
      }
    }
  }

  &__button.button.button--light ::v-deep {
    .button__bg {
      background-color: #F9DD6B;
    }

    a {
      color: #7A55E7;
    }

    a svg circle,
    a svg > path {
      stroke: #7A55E7;
    }
  }

  @include mq($and: $is-not-touch-device) {
    .index-block__button {
      transition: opacity 0.5s $outBack,
        transform 0.5s $outBack;
      opacity: 0;
      transform: translateY(20px);
    }

    .index-block__picture-text {
      transition: opacity 0.5s $outBack,
        transform 0.5s $outBack;

      &:nth-child(2) {
        opacity: 0;
        transform: translateX(-15px) rotate(-90deg);

        @include mq(ipadP) {
          transform: translateX(-20px) rotate(-90deg);
        }
      }

      &:nth-child(3) {
        opacity: 0;
        transform: translateX(15px) rotate(-90deg);

        @include mq(ipadP) {
          transform: translateX(20px) rotate(-90deg);
        }
      }
    }

    &:hover {
      .index-block__button {
        opacity: 1;
        transform: translateY(0);
      }

      .index-block__picture-text {
        &:nth-child(2) {
          opacity: 1;
          transform: translateX(-35px) rotate(-90deg);

          @include mq(ipadP) {
            transform: translateX(-40px) rotate(-90deg);
          }
        }

        &:nth-child(3) {
          opacity: 1;
          transform: translateX(35px) rotate(-90deg);

          @include mq(ipadP) {
            transform: translateX(40px) rotate(-90deg);
          }
        }
      }
    }
  }

  &__sold-out {
    position: absolute;
    width: 100px;
    top: -25px;
    left: -40px;
    z-index: 10;

    @include mq($until: ipadP) {
      width: 150px;
    }
  }
}
</style>

<style lang="scss">
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.index-block {
  .index-block__sold-out {
    animation: rotating 10s linear infinite;
  }
}
</style>
